// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d1c75e04","732":"9b8c30d1","977":"e0b4db16"}[chunkId] + ".chunk.js";
};